import styled from 'styled-components';

export const Wrapper = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;

  img {
    max-width: 100px;
  }
`;

export const Tagline = styled.div`
  color: pink;
  position: relative;
  top: 2px;
  margin-left: 5px;
  font-family: 'Playwrite TZ Guides', cursive;
`;

export const Version = styled.div`
  color: #ffffff11;
  position: absolute;
  top: 2px;
  left: 4px;
  font-size: 7px;
  font-family: monospace;
`;
